var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgSignInFormImage = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 547.729,
    height: 566.323,
    viewBox: "0 0 547.729 566.323",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .prefix__cls-1{fill:#575a89}.prefix__cls-2{fill:#3f3d56}.prefix__cls-3{fill:#fff}.prefix__cls-4{fill:#9aaeff}.prefix__cls-5{fill:#a0616a}.prefix__cls-6{fill:#d0cde1}.prefix__cls-7{opacity:.1}.prefix__cls-8{fill:#2f2e41}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_676",
    "data-name": "Group 676",
    transform: "translate(-525 -244)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6431",
    d: "M268.8 629.09l-6.117-24.128a313.323 313.323 0 00-33.24-11.926l-.772 11.213-3.133-12.349c-14.008-4-23.538-5.762-23.538-5.762s12.873 48.951 39.872 86.374l31.46 5.526-24.44 3.524a126.774 126.774 0 0010.933 11.586c39.276 36.457 83.023 53.184 97.711 37.36s-5.245-58.205-44.522-94.662c-12.176-11.3-27.472-20.372-42.783-27.51z",
    className: "prefix__cls-1",
    "data-name": "Path 6431",
    transform: "translate(323 -3.574)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6432",
    d: "M362.724 578.162l7.235-23.817a313.293 313.293 0 00-22.291-27.391l-6.457 9.2 3.7-12.194c-9.924-10.665-17.171-17.1-17.171-17.1s-14.283 48.558-10.515 94.55L341.3 622.4l-22.744-9.617a126.759 126.759 0 003.37 15.569c14.778 51.511 43.581 88.442 64.333 82.488s25.6-52.538 10.818-104.048c-4.581-15.969-12.987-31.639-22.4-45.664z",
    className: "prefix__cls-1",
    "data-name": "Path 6432",
    transform: "translate(287.258 21.151)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6433",
    d: "M876.605 742.366l4.552-4.916a84.311 84.311 0 00-2.177-9.253l-2.645 1.468 2.331-2.517c-1.149-3.749-2.147-6.159-2.147-6.159s-9.167 10.078-13.662 21.658l3.361 7.914-4.376-5a34.124 34.124 0 00-1.014 4.166c-2.478 14.21.154 26.539 5.879 27.537s12.375-9.712 14.853-23.922a44.924 44.924 0 00-.056-13.691z",
    className: "prefix__cls-1",
    "data-name": "Path 6433",
    transform: "translate(117.804 -45.635)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6434",
    d: "M969.237 757.87l6.438-1.856a84.33 84.33 0 002.919-9.046l-3.023-.11 3.3-.95c.954-3.8 1.345-6.383 1.345-6.383s-13.06 3.889-22.894 11.475l-1.213 8.512-1.161-6.545a34.119 34.119 0 00-3.022 3.042c-9.466 10.884-13.586 22.8-9.2 26.612s15.613-1.917 25.08-12.8a44.92 44.92 0 007.029-11.749z",
    className: "prefix__cls-1",
    "data-name": "Path 6434",
    transform: "translate(92.516 -51.417)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6435",
    d: "M616.168 127.344v421.231a33.235 33.235 0 01-33.223 33.23h-163.7A33.24 33.24 0 01386 548.571V127.344a33.239 33.239 0 0133.243-33.23H439.1a15.8 15.8 0 0014.62 21.756h93.328a15.8 15.8 0 0014.619-21.756h21.271a33.235 33.235 0 0133.229 33.223z",
    className: "prefix__cls-2",
    "data-name": "Path 6435",
    transform: "translate(265.611 149.886)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6436",
    d: "M512.276 340.2a16.431 16.431 0 018.223-14.237 16.44 16.44 0 100 28.473 16.429 16.429 0 01-8.223-14.236z",
    className: "prefix__cls-3",
    "data-name": "Path 6436",
    transform: "translate(231.353 78.26)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6437",
    d: "M542.312 340.2a16.431 16.431 0 018.224-14.237 16.44 16.44 0 100 28.473 16.429 16.429 0 01-8.224-14.236z",
    className: "prefix__cls-3",
    "data-name": "Path 6437",
    transform: "translate(221.985 78.26)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_3677",
    cx: 16.44,
    cy: 16.44,
    r: 16.44,
    className: "prefix__cls-4",
    "data-name": "Ellipse 3677",
    transform: "translate(768.055 402.022)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_1795",
    d: "M0 0H146.954V1.376H0z",
    className: "prefix__cls-3",
    "data-name": "Rectangle 1795",
    transform: "translate(693.292 526.056)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_3678",
    cx: 4.641,
    cy: 4.641,
    r: 4.641,
    className: "prefix__cls-4",
    "data-name": "Ellipse 3678",
    transform: "translate(693.292 508.181)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_1796",
    d: "M0 0H146.954V1.376H0z",
    className: "prefix__cls-3",
    "data-name": "Rectangle 1796",
    transform: "translate(693.292 572.462)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_3679",
    cx: 4.641,
    cy: 4.641,
    r: 4.641,
    className: "prefix__cls-4",
    "data-name": "Ellipse 3679",
    transform: "translate(693.292 554.588)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6438",
    d: "M574.055 375.729h-95.816a3.445 3.445 0 01-3.44-3.44v-95.817a3.445 3.445 0 013.44-3.44h95.816a3.445 3.445 0 013.441 3.44v95.816a3.445 3.445 0 01-3.441 3.441zm-95.816-101.321a2.067 2.067 0 00-2.064 2.064v95.816a2.066 2.066 0 002.064 2.064h95.816a2.067 2.067 0 002.064-2.064v-95.816a2.067 2.067 0 00-2.064-2.064z",
    className: "prefix__cls-3",
    "data-name": "Path 6438",
    transform: "translate(237.915 94.082)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "prefix__Rectangle_1797",
    width: 51.821,
    height: 21.656,
    className: "prefix__cls-4",
    "data-name": "Rectangle 1797",
    rx: 4,
    transform: "translate(788.426 603.315)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_1798",
    d: "M0 0H547.182V1.376H0z",
    className: "prefix__cls-2",
    "data-name": "Rectangle 1798",
    transform: "translate(525.547 731.016)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_674",
    "data-name": "Group 674",
    transform: "translate(-19922 -3364.174)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6472",
    d: "M1001.7 516.148s-5.884 28.766 3.923 26.151 5.884-27.459 5.884-27.459z",
    className: "prefix__cls-5",
    "data-name": "Path 6472",
    transform: "translate(19858.775 3477.368)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6473",
    d: "M1028.3 334.84h-6.538s-7.192 5.23-6.538 11.114-11.768 56.879-11.768 63.417-2.615 8.5-2.615 12.422 1.308 6.538 0 8.5-3.923 13.729-3.269 18.306a36.869 36.869 0 010 9.153h16.345s11.768-39.881 14.383-41.842a10.057 10.057 0 003.923-7.192c0-1.961-1.308-1.961 1.961-4.576s1.308-14.383 1.308-14.383l4.577-11.768z",
    className: "prefix__cls-6",
    "data-name": "Path 6473",
    transform: "translate(19859.633 3539.687)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6474",
    d: "M1028.3 334.84h-6.538s-7.192 5.23-6.538 11.114-11.768 56.879-11.768 63.417-2.615 8.5-2.615 12.422 1.308 6.538 0 8.5-3.923 13.729-3.269 18.306a36.869 36.869 0 010 9.153h16.345s11.768-39.881 14.383-41.842a10.057 10.057 0 003.923-7.192c0-1.961-1.308-1.961 1.961-4.576s1.308-14.383 1.308-14.383l4.577-11.768z",
    className: "prefix__cls-7",
    "data-name": "Path 6474",
    transform: "translate(19859.633 3539.687)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6475",
    d: "M903.7 491.648s-5.884 28.767 3.923 26.151 5.877-27.459 5.877-27.459z",
    className: "prefix__cls-5",
    "data-name": "Path 6475",
    transform: "translate(19892.703 3485.85)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6476",
    d: "M768.173 591l-3.923 16.345 14.383 9.153 3.923-19.614z",
    className: "prefix__cls-5",
    "data-name": "Path 6476",
    transform: "translate(20030.191 3520.522)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6477",
    d: "M870.442 622l-7.192 9.807 8.5 9.807h11.768V622z",
    className: "prefix__cls-5",
    "data-name": "Path 6477",
    transform: "translate(19995.916 3509.789)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6478",
    d: "M1018.27 742.354h-3.923a14.758 14.758 0 00-5.884 0c-3.923.654-9.246-5.639-9.246-5.639l-5.138 4.331s-10.461 2.615-5.23 15.037l11.768 7.192s5.884 12.422 17.652 10.461 3.269-15.037 3.269-15.037z",
    className: "prefix__cls-8",
    "data-name": "Path 6478",
    transform: "translate(19863.123 3400.551)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6479",
    d: "M892.738 707.058l-.995-4.355-8.812 2.394s-18.306-11.768-18.306 3.923 14.383 20.921 14.383 20.921 5.23-.654 5.23 3.923 13.729 11.768 18.96 9.153 5.23-9.153 5.23-9.153l-1.308-18.306-5.884 1.308s-11.114-.654-9.153-3.269.655-6.539.655-6.539z",
    className: "prefix__cls-8",
    "data-name": "Path 6479",
    transform: "translate(19905.625 3412.965)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6480",
    d: "M925.187 480.34s-7.845 10.461-7.845 16.345-2.615 58.187-2.615 58.187-14.383 66.686-10.461 70.609 15.691 9.807 17.652 7.845 15.691-73.226 15.691-73.226l16.344-43.8 15.037 62.763s-.654 54.264 1.961 54.918 3.923 1.308 2.615 3.923-3.269 7.845-3.269 7.845 16.345 3.923 19.614 1.308 3.923-66.032 0-88.261.654-73.224.654-73.224z",
    className: "prefix__cls-8",
    "data-name": "Path 6480",
    transform: "translate(19892.135 3489.312)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_3700",
    cx: 19.614,
    cy: 19.614,
    r: 19.614,
    className: "prefix__cls-5",
    "data-name": "Ellipse 3700",
    transform: "translate(20821.572 3803.918)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6481",
    d: "M964.057 272.234s2.615 13.729 0 17.652 35.3 1.308 35.3 1.308-18.306-20.921-16.345-24.844-18.955 5.884-18.955 5.884z",
    className: "prefix__cls-5",
    "data-name": "Path 6481",
    transform: "translate(19871.246 3563.72)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6482",
    d: "M934.461 302.848s13.076-17 29.42-13.729a410.74 410.74 0 0111.979 2.583 37.519 37.519 0 0127.065 23.813c1.1 3.126 1.655 6.129 1.165 8.581-1.961 9.807-.981 87.28-.981 87.28s-5.23 1.961-4.576 4.576 5.23 5.884.654 5.884-73.878-2.615-72.57-4.576 7.844-114.412 7.844-114.412z",
    className: "prefix__cls-6",
    "data-name": "Path 6482",
    transform: "translate(19884.17 3555.661)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6483",
    d: "M932.3 310.34h-6.54s-7.192 5.23-6.538 11.114-11.768 56.879-11.768 63.417-2.615 8.5-2.615 12.422 1.308 6.538 0 8.5-3.923 13.729-3.269 18.306a36.866 36.866 0 010 9.153h16.345s11.768-39.881 14.383-41.842a10.057 10.057 0 003.923-7.192c0-1.961-1.308-1.961 1.961-4.576s1.308-14.383 1.308-14.383l4.576-11.768z",
    className: "prefix__cls-6",
    "data-name": "Path 6483",
    transform: "translate(19892.869 3548.169)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6484",
    d: "M796.671 354.769l19.665-43.269-9.836 46.017z",
    className: "prefix__cls-7",
    "data-name": "Path 6484",
    transform: "translate(20018.967 3617.29)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6485",
    d: "M956.7 208.21l.01-1.618a12.621 12.621 0 014.058.142 6.59 6.59 0 00-.594-2.834 12.827 12.827 0 013.88 1.155l.451-3.006 11.71 4.1c4.2 1.473 8.646 3.113 11.374 6.634 3.042 3.925 3.262 9.418 2.095 14.244s-3.543 9.261-5.315 13.9a32.869 32.869 0 01-2.488 5.718c-3.539 5.705-11.53 7.741-17.791 5.317a10.592 10.592 0 01-5.664-4.57 33.934 33.934 0 01-1.527-4.168c-1.088-2.883-2.677-8.913-5.318-10.5-1.162-.7-2.935 2.3-3.938 1.388-2.579-2.343-2.595-6.437-1.574-9.768a72.153 72.153 0 013.6-9.768c.608-1.276 7.031-6.56 7.031-6.366z",
    className: "prefix__cls-8",
    "data-name": "Path 6485",
    transform: "translate(19877.648 3585.661)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSignInFormImage);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/signInFormImage.455725046448e5c6fb5d5c792a00ad16.svg";